// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-903e8d3b] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
li.action.active[data-v-903e8d3b] {
  background-color: var(--color-background-hover);
  border-radius: 6px;
  padding: 0;
}
.action--disabled[data-v-903e8d3b] {
  pointer-events: none;
  opacity: 0.5;
}
.action--disabled[data-v-903e8d3b]:hover, .action--disabled[data-v-903e8d3b]:focus {
  cursor: default;
  opacity: 0.5;
}
.action--disabled *[data-v-903e8d3b] {
  opacity: 1 !important;
}
.action-button[data-v-903e8d3b] {
  display: flex;
  align-items: flex-start;
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
  padding-inline-end: calc((var(--default-clickable-area) - 16px) / 2);
  box-sizing: border-box;
  cursor: pointer;
  white-space: nowrap;
  color: var(--color-main-text);
  border: 0;
  border-radius: 0;
  background-color: transparent;
  box-shadow: none;
  font-weight: normal;
  font-size: var(--default-font-size);
  line-height: var(--default-clickable-area);
}
.action-button > span[data-v-903e8d3b] {
  cursor: pointer;
  white-space: nowrap;
}
.action-button__icon[data-v-903e8d3b] {
  width: var(--default-clickable-area);
  height: var(--default-clickable-area);
  opacity: 1;
  background-position: calc((var(--default-clickable-area) - 16px) / 2) center;
  background-size: 16px;
  background-repeat: no-repeat;
}
.action-button[data-v-903e8d3b] .material-design-icon {
  width: var(--default-clickable-area);
  height: var(--default-clickable-area);
  opacity: 1;
}
.action-button[data-v-903e8d3b] .material-design-icon .material-design-icon__svg {
  vertical-align: middle;
}
.action-button__longtext-wrapper[data-v-903e8d3b], .action-button__longtext[data-v-903e8d3b] {
  max-width: 220px;
  line-height: 1.6em;
  padding: calc((var(--default-clickable-area) - 1.6em) / 2) 0;
  cursor: pointer;
  text-align: start;
  overflow: hidden;
  text-overflow: ellipsis;
}
.action-button__longtext[data-v-903e8d3b] {
  cursor: pointer;
  white-space: pre-wrap !important;
}
.action-button__name[data-v-903e8d3b] {
  font-weight: bold;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 100%;
  display: inline-block;
}
.action-button__menu-icon[data-v-903e8d3b] {
  margin-inline: auto calc((var(--default-clickable-area) - 16px) / 2 * -1);
}
.action-button__pressed-icon[data-v-903e8d3b] {
  margin-inline: auto calc((var(--default-clickable-area) - 16px) / 2 * -1);
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcActionButton-BT4157Cp.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;EAGE;AACF;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,oEAAoE;EACpE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;EACnC,0CAA0C;AAC5C;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,UAAU;EACV,4EAA4E;EAC5E,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4DAA4D;EAC5D,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,yEAAyE;AAC3E","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-903e8d3b] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\nli.action.active[data-v-903e8d3b] {\n  background-color: var(--color-background-hover);\n  border-radius: 6px;\n  padding: 0;\n}\n.action--disabled[data-v-903e8d3b] {\n  pointer-events: none;\n  opacity: 0.5;\n}\n.action--disabled[data-v-903e8d3b]:hover, .action--disabled[data-v-903e8d3b]:focus {\n  cursor: default;\n  opacity: 0.5;\n}\n.action--disabled *[data-v-903e8d3b] {\n  opacity: 1 !important;\n}\n.action-button[data-v-903e8d3b] {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  height: auto;\n  margin: 0;\n  padding: 0;\n  padding-inline-end: calc((var(--default-clickable-area) - 16px) / 2);\n  box-sizing: border-box;\n  cursor: pointer;\n  white-space: nowrap;\n  color: var(--color-main-text);\n  border: 0;\n  border-radius: 0;\n  background-color: transparent;\n  box-shadow: none;\n  font-weight: normal;\n  font-size: var(--default-font-size);\n  line-height: var(--default-clickable-area);\n}\n.action-button > span[data-v-903e8d3b] {\n  cursor: pointer;\n  white-space: nowrap;\n}\n.action-button__icon[data-v-903e8d3b] {\n  width: var(--default-clickable-area);\n  height: var(--default-clickable-area);\n  opacity: 1;\n  background-position: calc((var(--default-clickable-area) - 16px) / 2) center;\n  background-size: 16px;\n  background-repeat: no-repeat;\n}\n.action-button[data-v-903e8d3b] .material-design-icon {\n  width: var(--default-clickable-area);\n  height: var(--default-clickable-area);\n  opacity: 1;\n}\n.action-button[data-v-903e8d3b] .material-design-icon .material-design-icon__svg {\n  vertical-align: middle;\n}\n.action-button__longtext-wrapper[data-v-903e8d3b], .action-button__longtext[data-v-903e8d3b] {\n  max-width: 220px;\n  line-height: 1.6em;\n  padding: calc((var(--default-clickable-area) - 1.6em) / 2) 0;\n  cursor: pointer;\n  text-align: start;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.action-button__longtext[data-v-903e8d3b] {\n  cursor: pointer;\n  white-space: pre-wrap !important;\n}\n.action-button__name[data-v-903e8d3b] {\n  font-weight: bold;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  max-width: 100%;\n  display: inline-block;\n}\n.action-button__menu-icon[data-v-903e8d3b] {\n  margin-inline: auto calc((var(--default-clickable-area) - 16px) / 2 * -1);\n}\n.action-button__pressed-icon[data-v-903e8d3b] {\n  margin-inline: auto calc((var(--default-clickable-area) - 16px) / 2 * -1);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
